import { currencyService } from '../../services';
import { CurrencyCode, CurrencyGetAllResponse } from '../../types';
import { useQuery } from '../use-query';

const getConvertCurrency =
  (currencies: CurrencyGetAllResponse['data']) =>
  (from: CurrencyCode, to: CurrencyCode, value: number) => {
    const fromCurrency = currencies.find((c) => c.code === from);
    const toCurrency = currencies.find((c) => c.code === to);

    if (!fromCurrency || !toCurrency) {
      return value;
    }

    if (from === to) return value;

    const valueInUSD = value / fromCurrency.unitsPerUSD;
    const convertedValue = valueInUSD * toCurrency.unitsPerUSD;

    return convertedValue;
  };

export const useConvertCurrencyFcQuery = () => {
  const timeKey = new Date().toLocaleString('ru-RU', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    hour12: false,
  });

  const { data } = useQuery(
    ['currency', timeKey],
    async () => {
      const currencies = await currencyService.getAll().then((res) => res.data.data);

      return currencies;
    },
    {
      initialData: [],
      keepPreviousData: true,
    },
  );

  return getConvertCurrency(data || []);
};
